import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-testimonials").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Navigation],
    speed: 750,
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
    },
  });
});
